import React, { useState, useEffect } from 'react';
import { Dropdown, Input, Icon } from 'antd';
import CheckMarkMenu from '../../../../components/CheckMarkMenu/CheckMarkMenu';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { getReplacedString } from '../../../../helpers/getReplacedString';
import useSearchParams from '../../../../hooks/useSearchParams';

const SelectItem = ({
  ringListLoading = false,
  defaultBtnText,
  filterData,
  items,
  itemsLoading,
  contentKey = 'name',
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [btnText, setBtnText] = useState(defaultBtnText);
  const [searchValue, setSearchValue] = useState('');

  const [filterVal, setFilterVal] = useSearchParams(filterData);

  const handleMenuClick = (val) => {
    if (val.id !== filterVal) {
      setFilterVal(val.id);
    }

    setDropdownVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const handleSearch = (e) => {
    const val = e.target.value;

    const value = getReplacedString(val);

    const filteredItems = items?.length
      ? items.filter((item) => {
          const itemData = getReplacedString(item[contentKey]);
          return itemData.includes(value);
        })
      : [];

    setFilteredItems(filteredItems);
    setSearchValue(val);
  };

  useEffect(() => {
    if (items?.length > 0) {
      setFilteredItems(items);
    }
  }, [items]);

  useEffect(() => {
    if (!dropdownVisible) {
      setSearchValue('');
      setFilteredItems(items || []);
    }
  }, [dropdownVisible, items]);

  useEffect(() => {
    let text;

    if (itemsLoading) {
      text = 'Загрузка...';
    } else if (items?.length > 0 && filterVal) {
      const currentItem = items.find((item) => item.id === filterVal);
      text = currentItem?.[contentKey] || defaultBtnText;
    } else {
      text = defaultBtnText;
    }

    setBtnText(text);
  }, [itemsLoading, items, filterVal, defaultBtnText]);

  return (
    <Dropdown
      trigger={['click']}
      visible={dropdownVisible}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
      disabled={itemsLoading || ringListLoading}
      overlay={
        <CheckMarkMenu
          items={filteredItems}
          selectedItems={[filterVal]}
          renderContent={(item) => item[contentKey]}
          visible={dropdownVisible}
          renderSearchInput={({ inputRef }) => (
            <Input ref={inputRef} onChange={handleSearch} value={searchValue} />
          )}
          handlers={{
            onMenuClick: handleMenuClick,
          }}
        />
      }
    >
      <RoundedButton
        text={btnText}
        type="secondary"
        iconRight={<Icon type="caret-down" />}
      />
    </Dropdown>
  );
};

export default SelectItem;
